import { render } from "./Sites.page.vue?vue&type=template&id=bd86c220&ts=true"
import script from "./Sites.page.vue?vue&type=script&lang=ts"
export * from "./Sites.page.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__